import api from '@/libs/axios'


export default {
  async create(payload) {
    const response = await api.post('/earns/admin/gift-categorys', payload)
    return response.data.data.new_document || null
  },
  async update(payload) {
    let response = await api.put('/earns/admin/gift-categorys', payload)
    return response
  },
  async delete(payload) {
    const response = await api.delete('/earns/admin/gift-categorys', {
      data: payload,
    })
    return response
  },
  async getList(params) {
    let response = await api.get('/earns/admin/gift-categorys', {
      params,
    })
    return response
  },
  async get(params) {
    let response = await api.get('/earns/admin/gift-categorys/detail', {
      params,
    })
    return response.data.data.document || null
  },
}
